import { Spinner } from '../../../shared/ui/Spinner'

/** Какой справочник ждёт экран — от этого зависит текст плашки. */
type What = 'rates' | 'rates+markup'

type Props = {
  isLoading: boolean
  onRetry: () => void
  /** По умолчанию `rates+markup` — кейс карточки заявки (курсы + наценки). */
  what?: What
}

const TEXTS: Record<What, { loading: string; error: string }> = {
  'rates+markup': {
    loading: 'Загружаем курсы и коэффициенты наценки…',
    error: '⚠ Курсы и коэффициенты не загрузились — цены в рублях и КП посчитать нельзя.',
  },
  rates: {
    loading: 'Загружаем курсы валют…',
    error: '⚠ Курсы валют не загрузились — цену квоты в позицию записать нельзя.',
  },
}

/**
 * Плашка «цены посчитать нельзя».
 *
 * `what: 'rates+markup'` (по умолчанию) — карточка заявки: показывается вместо
 * кнопки «Выставить КП», пока не загружены курс CNY и коэффициенты наценки.
 * Молча подставлять фолбэк-курс нельзя: КП уходил клиенту дешевле в 12,5 раза.
 *
 * `what: 'rates'` — страница позиции: там грузятся только курсы валют
 * (useMatrixRates), коэффициенты наценки не нужны и не запрашиваются.
 *
 * Разметка — та же красная плашка с кнопкой «Повторить», что и у
 * RequestLoadError (эталон из docs/ui-conventions.md).
 */
export function PricingNotReady({ isLoading, onRetry, what = 'rates+markup' }: Props) {
  const text = TEXTS[what]

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <Spinner className="w-4 h-4" />
        {text.loading}
      </div>
    )
  }

  return (
    <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-sm flex items-center justify-between gap-3">
      <span>{text.error}</span>
      <button
        onClick={onRetry}
        className="px-2 py-1 bg-white border border-red-300 rounded text-red-700 hover:bg-red-100 text-xs"
      >
        Повторить
      </button>
    </div>
  )
}
